import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppService } from '../services/app.service';

enum PublicRoutes {
  SIGNIN = 'signin',
  SIGNUP = 'signup',
  SIGNUP_TYPE = 'signup/:type?',
  RESET_PASSWORD = 'reset-password'
}

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AppService);
  const router = inject(Router);

  const path = route.routeConfig?.path;
  const isLoggedIn = authService.isUserLoggedIn();

  // Check for public routes when user is already logged in
  const isPublicRoute = [
    PublicRoutes.SIGNIN,
    PublicRoutes.SIGNUP,
    PublicRoutes.SIGNUP_TYPE,
    PublicRoutes.RESET_PASSWORD
  ].includes(path as PublicRoutes);

  // Redirect logged-in users from public routes
  if (isPublicRoute && isLoggedIn) {
    authService.handleRedirect();
    return false;
  }

  // Require authentication for non-public routes
  const isProtectedRoute = !isPublicRoute;
  if (isProtectedRoute && !isLoggedIn) {
    router.navigate(['/signin']);
    return false;
  }

  if (isProtectedRoute && isLoggedIn) {
    // Special handling for routes
    const isOnboardingRoute = state.url.includes('/complete-onboarding');
    const voiceAgentRoute = state.url.includes('/va');
    const isWhatsAppRoute = state.url.includes('/wa');
    const isFacebookRoute = state.url.includes('/fb');
    const hasValidWhatsAppAccess = isWhatsAppRoute &&
      authService.selectedAsset()?.type === 'waba';
    const hasValidFacebookAccess = isFacebookRoute &&
      authService.selectedAsset()?.type === 'facebook';

    if (isOnboardingRoute && authService.selectedAsset()?.type) {
      authService.handleRedirect();
      return false;
    }

    if (hasValidWhatsAppAccess) {
      return true;
    }

    if (hasValidFacebookAccess) {
      return true;
    }
  }

  // Default to allowing access
  return true;
};
